export default "__VITE_ASSET__K5Z34P2u__"